import { Box, Grid } from '@material-ui/core';
import { IProjectLearner } from 'app/models/responses/IProjectLearner';
import React from 'react';
import { Files, General, Hosting } from './components';

interface IProps {
  projectLearner: IProjectLearner;
  onSave: (projectLearner: IProjectLearner) => void;
}

const Details: React.FC<IProps> = (props) => {
  const { projectLearner, onSave } = props;

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={6}>
        <General projectLearner={projectLearner} onSave={onSave} />
      </Grid>
      <Grid item xs={12} md={6}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Files projectLearner={projectLearner} onSave={onSave} />
          </Grid>
          <Grid item xs={12} md={6}>
            <Hosting projectLearner={projectLearner} onSave={onSave} />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default Details;
